import { LoadingBlock, Table } from '@orobix/orobix-fe-components'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import InfiniteScroll from 'react-infinite-scroller'
import { useQueryClient } from 'react-query'

import { createSocket } from '../../../utils/webSocket'
import { useColumns } from './useColumns'
import { useOptimizationProcesses } from './useOptimizationProcesses'
import { useQueryParamFiltering } from './useQueryParamFiltering'

export const OptimizationProcessesList = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  const { filtering, sorting, handleSort, handleFilter } =
    useQueryParamFiltering<string>()

  const { data, isEmpty, hasNextPage, fetchNextPage } =
    useOptimizationProcesses({ sorting, filtering })

  const columns = useColumns({
    sorting,
    filtering,
    handleSort,
    handleFilter,
  })

  useEffect(() => {
    const websocket = createSocket('/optimization-process/status')

    websocket.onmessage = (event: MessageEvent<string>) => {
      queryClient.invalidateQueries(['optimization-processes'])
    }

    return () => {
      websocket.close()
    }
  }, [queryClient])

  return (
    <InfiniteScroll
      loadMore={() => fetchNextPage()}
      hasMore={hasNextPage}
      loader={<LoadingBlock message={t('Loading')} key="loading" />}
    >
      <div className="opt-processes-table">
        <Table
          columns={columns}
          data={data}
          alternateRows
          stickyHeader
          isEmpty={isEmpty}
          emptyMessage={t(
            `There's nothing here. Try creating a new {{ itemName }}.`,
            { itemName: t('optimization process') }
          )}
        />
      </div>
    </InfiniteScroll>
  )
}
